export default __webpack_public_path__ + "static/media/2. Conversation.f383eb6d.wav";